<template>
  <div class="modal fade" :class="modalClass" :id="id" :data-bs-backdrop="backdrop" data-bs-keyboard="false"
    tabindex="-1" aria-hidden="true" ref="modalRef">
    <div class="modal-dialog" :class="modal_classes">
      <div class="modal-content">
        <div class="modal-header">
          <slot name="header">
            <h1 class="modal-title fs-5"><d-text>{{ title }}</d-text></h1>
            <button v-if="!hideheaderclose" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </slot>
        </div>
        <div class="modal-body">
          <slot></slot>
        </div>
        <div class="modal-footer" :class="footerclass" >
          <slot name="footer">
            <d-button v-if="!hidebuttons" type="button" :variant="closebtnVariant" data-bs-dismiss="modal"><d-text>{{ closebtntext}}</d-text></d-button>
            <d-button v-if="!hideok && !hidebuttons" type="button" :variant="okbtnVariant" @click="OkClick"><d-text>{{ okbtntext }}</d-text></d-button>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>

import { ref, computed, defineProps, defineEmits, defineExpose, onMounted } from 'vue'
import { Modal } from 'bootstrap'; // Import Bootstrap's JavaScript

const modalRef = ref(null); // Ref for the modal element
let modalInstance = null;

// Expose the method to allow the parent to access it
defineExpose({
  Open,
  Close
});

// emits
const emit = defineEmits(['OkClick', 'Closed'])
// props
const props = defineProps({
  id: { type: String, required: true },
  title: { type: String },
  center: { type: Boolean, default: false },
  scroll: { type: Boolean, default: false },
  backdrop: { type: String, default: "static" },
  hidebuttons: {type: Boolean, default: false},
  hideheaderclose: {type: Boolean, default: false},
  closebtntext: { type: String, default: "Button_Close" },
  okbtntext: { type: String, default: "Button_Ok" },
  hideok: { type: Boolean, default: false },
  variant: { type: String, default: "" },
  closebtnVariant: { type: String, default: "secondary" },
  okbtnVariant: { type: String, default: "primary" },
  footerclass: { type: String, default: "" },
  size: { type: String, default: "" },
})

const modalClass = computed(() => {
  var className = props.variant;
  className += " modal-" + props.size;

  return className
})

// computed
const modal_classes = computed(() => {
  var cnames = "";
  if (props.center)
    cnames += " modal-dialog-centered";
  if (props.scroll)
    cnames += " modal-dialog-scrollable";
  return cnames
})

// functions
function OkClick() {
  emit("OkClick");
}

function Open() {
  if (modalInstance) {
    modalInstance.show(); // Programmatically open the modal
  }
}


function Close(skip_emit) {
  if (modalInstance) {
    modalInstance.hide(); // Programmatically close the modal
  }
  if(!skip_emit)
    emit("Closed");
}



// Initialize the Bootstrap modal instance
onMounted(() => {
  modalInstance = new Modal(modalRef.value);
    modalRef.value.addEventListener('hidden.bs.modal', () => {
      Close();
  });
});

</script>